import React from "react";
import { LabelCheckBox, MemberSecureCard, PrivacyDataToggle } from "@icoach/components";
import SmartFitnessBandMoreLabel from "@icoach/smartFitnessBand/components/SmartFitnessBandMoreLabel";
import { MemoControllerBox } from "@icoach/components";
import { SpecialConditionBox } from "@icoach/components/";
import { isEqual, getEnabledActionKeys, parseCardExpiry } from "@util/utils";
import { parseDate } from "@util/moment";

// 租約列表下拉操作選項
export const getMoreActionArray = (data = {}) => {
	const { canQuit = true, canDelete = true, canQuitDelete = false } = data;
	const moreAction = {
		view: true,
		editCreditCard: true,
		quit: canQuit,
		quitDelete: canQuitDelete,
		delete: canDelete,
		sms: true,
	};
	return getEnabledActionKeys(moreAction);
};

export const rowsLabel = [
	{
		isIcon: true,
		maxWidth: 7,
		width: 7,
		formatCell: (value, rowData, { checkBoxsRef, onCheckBoxChange, getCheckedItems, sequence }) => {
			let isChecked = false;
			const key = `${value}_${sequence}`;
			if ((getCheckedItems() || []).includes(key)) isChecked = true;
			return (
				<LabelCheckBox
					ref={el => (checkBoxsRef.current[key] = el)}
					onChange={onCheckBoxChange}
					idKey={key}
					defalutCehecked={isChecked}
					sourceData={rowData}
					disabled={isEqual(rowData.redeemStatus, 1)}
				/>
			);
		},
	},
	{
		cellKey: "memberNo",
		headerLabel: "租用會員",
		maxWidth: 20.4,
		formatCell: (memberNo, { displayName, maskDisplayName, memberImg, nickName, membershipStatus }, { isRevealed }) => {
			return (
				<MemberSecureCard
					avatar={memberImg}
					name={displayName}
					maskName={maskDisplayName}
					nickname={nickName}
					memberNo={memberNo}
					membershipStatus={membershipStatus}
					// link={CLUB_MEMBERS_ROUTER.CABINET.GET_CONTRACT_RENTCABINETID_PATH("contract-review", cabinetRentalID)}
					isRevealed={isRevealed}
				/>
			);
		},
	},
	{
		cellKey: "cellPhone",
		headerLabel: "手機號碼",
		formatCell: (cellPhone, { maskCellPhone }, { isRevealed }) => {
			return <PrivacyDataToggle fullData={cellPhone} maskedData={maskCellPhone} isRevealed={isRevealed} />;
		},
	},
	{
		cellKey: "specialCondition",
		headerLabel: "聯繫注意與偏好",
		maxWidth: 20.4,
		formatCell: (value, { memberID }) => {
			return <SpecialConditionBox sourceData={{ memberID, value: value }} />;
		},
	},
	{
		cellKey: "applyDate",
		headerLabel: "開通日",
		align: "center",
		formatCell: dateTime => {
			return parseDate(dateTime);
		},
	},
	{
		cellKey: "endDate",
		headerLabel: "結束日",
		align: "center",
		formatCell: dateTime => {
			return parseDate(dateTime);
		},
	},
	{
		cellKey: "deviceOrderStatusText",
		headerLabel: "租借狀態",
		align: "center",
	},
	{
		cellKey: "cardExpiryDate",
		headerLabel: "信用卡效期",
		align: "center",
		formatCell: cardExpiryDate => {
			return parseCardExpiry(cardExpiryDate);
		},
	},
	{
		cellKey: "note",
		headerLabel: "備註",
		formatCell: value => {
			return <MemoControllerBox data={value} dialogTitle={"備註"} />;
		},
	},
	{
		cellKey: "more",
		headerLabel: "",
		align: "right",
		isIcon: true,
		formatCell: (_, rowsData, others) => {
			return <SmartFitnessBandMoreLabel moreActionArray={getMoreActionArray(rowsData)} rowsData={rowsData} {...others} />;
		},
	},
];
